import React from 'react';
import CardButton from '../CardButton/CardButton';
import './LeaderboardSlide.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {view_leaderboard} from '../../../../../cosmosTracking/cosmosEvents';
import LeaderBoardTopInt from "../../LeaderboardInt/LeaderBoardTopInt";
import holippl from '../../../../../assets/images/holi-people.png';
import { resolveTutorHomeAsset, globalText } from '../tutorHomeConfig';
import { tutorDetailsLeaderboardConfig, globalColors, globalBackgrounds } from '../../LeaderboardInt/tutorDetailsLeaderboardConfig';
function LeaderboardSlide(props) {
    const { data, deepLink, rewardText, config = {} } = props;
    const leaderboardBackgrounds = tutorDetailsLeaderboardConfig.backgrounds || {};
    const podiumStyle = {
        '--leaderboard-podium-background': globalColors.card_background || '#FFF1DAB2',
        '--leaderboard-podium-border': globalColors.accent_color || '#E35C22',
        '--leaderboard-podium-accent': globalColors.accent_color || '#E35C22',
        '--leaderboard-first-place-background': globalColors.light_accent || '#FFD3B1',
        '--leaderboard-points-label': globalColors.accent_color || '#E35C22',
        '--leaderboard-rank-badge-gradient': globalColors.accent_color || '#E35C22',
        '--leaderboard-inverse-text': globalColors.white_text || '#fff',
        '--leaderboard-points-gradient': leaderboardBackgrounds.points_gradient || 'linear-gradient(180deg, #D51437 0%, #930F27 100%)',
    };
    return (
        <div className="slideCard slideCardBoard" style={podiumStyle}>
            <div className="cardBody" style={config.images?.card_background ? {'--tutor-home-card-background': `url("${resolveTutorHomeAsset(config.images.card_background)}")`} : undefined}>

            <div className="body-card-inner">
            <img className="leader-board-top-img" src={resolveTutorHomeAsset(config.images?.header_artwork)} alt="title"/>
            </div>
                
                <LeaderBoardTopInt data={data} config={tutorDetailsLeaderboardConfig}/>
                <CardButton
                    text={globalText.view_leaderboard_label || 'View Leaderboard'}
                    deeplink={deepLink}
                    className={'btn-action'}
                    eventCallback={() => {
                        cosmosTrackService(view_leaderboard);
                    }}/>
            </div>
        </div>
    );
}

export default LeaderboardSlide;
